import React from "react";
import Button from "../../../../components/Button";
import Container from "@material-ui/core/Container";
import Loading from "../../../../components/Loading";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { AdapterLink } from "../../../../components/Adopter";
import { useQuery } from "react-query";
import { mutateErrors } from "../../../../utils";
import Error from "../../../../components/Error";
import useMajorQueries from "../../hooks/useMajorQueries";
import PageHeader from "../../../../components/PageHeader";
import { Routes } from "../../../../constants/routes";
import Grid from "@material-ui/core/Grid";
import MajorListItem from "../../components/MajorListItem";
import { QUERY_KEYS } from "../../../../constants";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
  },
}));

export default function ListPage() {
  const classes = useStyles();
  const { fetchAll } = useMajorQueries();
  const { majors } = QUERY_KEYS;

  const { isLoading, isFetching, isError, error, refetch, data } =
    useQuery<any>(majors, fetchAll);

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <>
      <Container maxWidth="lg">
        <PageHeader
          title={"Majors"}
          subtitle={"Here are listed program majors"}
          endAdornment={
            <Button
              color={"success"}
              variant={"contained"}
              component={AdapterLink}
              to={`/0/${Routes.MAJORS}/create`}
            >
              Add
            </Button>
          }
        />
      </Container>

      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={2}>
          {data &&
            data.data.map((major: any, index) => (
              <MajorListItem
                onDelete={refetch}
                index={index}
                major={major}
                key={`MajorListItem_${index}`}
              />
            ))}
        </Grid>
      </Container>
    </>
  );
}
